import React, { useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
import ImageUpload from './../../compoments/ImageUpload'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  }
}));

export default function ClientesUpdate({ match }) {

  const role = 'clientes';
  const roleName = 'Clientes';

  const [redirect, setRedirect] = React.useState(false);
  const [id, setId] = React.useState('');
  const [name, setName] = React.useState('');
  const [cod, setCod] = React.useState('');
  const [cpf, setCpf] = React.useState('');
  // const [email, setEmail] = React.useState('');
  // const [email, setEmail] = React.useState('');
  // const [birthday, setBirthday] = React.useState('');
  // const [stateAddress, setStateAddress] = React.useState('');
  // const [city, setCity] = React.useState('');
  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');  
  // const [previewImage, setPreviewImage] = React.useState('');
  // const [thumbnail, setThumbnail] = React.useState(null);
  // const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);

  // const preview = useMemo(() => {
  //   return thumbnail ? URL.createObjectURL(thumbnail) : null
  // }, [thumbnail])


  const loadData = async () => {
    setId(match.params.id)
    const data = await api.get('/v1/clients/' + match.params.id)
    setName(data.data.name)
    setCod(data.data.cod)
    setCpf(data.data.cpf)
    // const birthday = data.data.birthday ?
    //   data.data.data.birthday.split('-').reverse().join('/') : '';
    // setBirthday(birthday || '')
    // setStateAddress(data.data.data.state || '')
    // setCity(data.data.data.city)
    // if( data.data.data &&  data.data.data.photo_thumb ){
    //   const photoUrl = `${data.data.data.photo_thumb.base_url+data.data.data.photo_thumb.photo_url}`
    //   setPreviewImage(photoUrl)
    // }
  }

  useEffect(() => {
    loadData()
  }, [])

  const save = async () => {

    const user = new FormData();
    // user.append('photo', thumbnail)
    user.append('name', name)
    user.append('cod', cod)
    user.append('cpf', cpf)
    // user.append('stateAddress', stateAddress)
    // user.append('city', city)
    // user.append('previewImage', previewImage)
    // user.append('crop', JSON.stringify(croppedAreaPixels))
    user.append('_method', 'PUT')
    try { 
      const data = await api.post('/v1/clients/' + id, user, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      })
      setAlertTitle('')
      setRedirect(`/clientes`)
    } catch(error) {
      setAlertTitle('Erro')
      setMessage(error.response.data.errors[0].message || 'Erro')
    }

  }

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      <Header titleHeader={'Editar Clientes'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={`/${role}`} >
                  {roleName}
                </Link>
                <Typography color="textPrimary">Cadastro</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} >
                      <TextField
                        variant="outlined"
                        fullWidth
                        id="cod"
                        label="Código"
                        name="cod"
                        autoComplete="cod"
                        value={cod}
                        onChange={(e) => setCod(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="cpf"
                        label="Cpf"
                        type="text"
                        id="cpf"
                        value={cpf}
                        onChange={(e) => setCpf(e.target.value)}
                      />
                    </Grid>
                    {/* <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="state"
                        label="Estado"
                        type="text"
                        id="state"
                        value={stateAddress}
                        onChange={(e) => setStateAddress(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="city"
                        label="Cidade"
                        type="text"
                        id="city"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid item xs={6}>
                        <ImageUpload 
                          onCropComplete={(croppedArea, croppedAreaPixels)=>{
                            setCroppedAreaPixels(croppedAreaPixels)
                          }}
                          onChange={event => setThumbnail(event.target.files[0])}
                          previewChange={preview}  
                          previewImage={previewImage}
                          remove={(flag)=> {
                            if(flag){
                              setPreviewImage('');
                            }
                            setThumbnail(null);
                          }}
                        />
                      </Grid>
                    </Grid> */}
                    <Grid item xs={6}>
                      <Button
                        onClick={() => {
                          setRedirect(`/${role}`)
                        }}
                        type="button"
                        variant="contained"
                        color="default"
                        style={{ marginRight: 30 }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={save}
                      >
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}